import { useState, useCallback, useRef } from 'react'

export const useScrollThreshold = (threshold: number = 0.15) => {
  const [isScrolledPastThreshold, setIsScrolledPastThreshold] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const handleScroll = useCallback(() => {
    if (scrollContainerRef.current) {
      const { scrollTop } = scrollContainerRef.current
      const thresholdValue = window.innerHeight * threshold
      setIsScrolledPastThreshold(scrollTop > thresholdValue)
    }
  }, [threshold])

  const resetScrollPosition = useCallback(() => {
    setIsScrolledPastThreshold(false)
  }, [])

  return {
    scrollContainerRef,
    handleScroll,
    isScrolledPastThreshold,
    resetScrollPosition,
  }
}
